import { render, staticRenderFns } from "./AtomInputGroupPrimary.vue?vue&type=template&id=877da588&"
import script from "./AtomInputGroupPrimary.vue?vue&type=script&lang=js&"
export * from "./AtomInputGroupPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports